import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { SyllabusQuery } from '@examdojo/category/v2';
import { distinctUntilChanged, filter, tap } from 'rxjs';
import { RootUrlParts } from '../../app.model';
import { ActiveSyllabusManager } from '../../storage/active-syllabus-manager';

@Injectable({
  providedIn: 'root',
})
export class NavigateOnActiveSyllabusChangeService {
  constructor(
    private readonly syllabusQuery: SyllabusQuery,
    private readonly router: Router,
    private readonly activeSyllabusManager: ActiveSyllabusManager,
  ) {
    this.navigateOnActiveSyllabusChange().pipe(takeUntilDestroyed()).subscribe();
  }

  navigateOnActiveSyllabusChange() {
    return this.syllabusQuery.selectActive().pipe(
      distinctUntilChanged((prev, curr) => prev?.id === curr?.id),
      filter(Boolean),
      tap((newSyllabus) => {
        // Save slug via ActiveSyllabusManager
        this.activeSyllabusManager.setActiveSyllabusSlug(newSyllabus.slug);

        // Get current URL and extract syllabusSlug from it
        const currentUrl = this.router.url;
        const urlMatch = currentUrl.match(new RegExp(`/${RootUrlParts.Syllabus}/([^/]+)(/.*)?`));

        if (urlMatch) {
          const currentSyllabusSlug = urlMatch[1];

          // Only navigate if the syllabusSlug is different
          if (currentSyllabusSlug !== newSyllabus.slug) {
            const remainingPath = urlMatch[2] || '';
            const newUrl = `/syllabus/${newSyllabus.slug}${remainingPath}`;
            this.router.navigateByUrl(newUrl);
          }
        }
      }),
    );
  }
}
